// Chrome fires `beforeinstallprompt` once per page load, as soon as the install
// criteria are met — and that is almost always *before* the vendor is logged in.
// The banner lives inside Dashboard, which only mounts after the token check
// round-trips (App.js), so a listener registered there arrives too late and the
// event is lost for good — logging in is a state change, not a reload, so it
// never fires again. Capture it here at module load instead, and hand it to the
// banner whenever it is ready to ask.

let deferredPrompt = null;
const listeners = new Set();

function notify() {
  listeners.forEach(fn => fn(deferredPrompt));
}

window.addEventListener('beforeinstallprompt', event => {
  // Stop Chrome's own mini-infobar so we control when the vendor is asked.
  event.preventDefault();
  deferredPrompt = event;
  notify();
});

window.addEventListener('appinstalled', () => {
  // A prompt can only be used once, and there is nothing left to install.
  deferredPrompt = null;
  notify();
});

export function getInstallPrompt() {
  return deferredPrompt;
}

// Returns an unsubscribe function.
export function onInstallPromptChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

// Show the native install dialog. Resolves to true if the vendor accepted.
export async function showInstallPrompt() {
  if (!deferredPrompt) return false;
  const prompt = deferredPrompt;
  // Consume it up front — the same event object cannot be prompted twice.
  deferredPrompt = null;
  prompt.prompt();
  const { outcome } = await prompt.userChoice;
  notify();
  return outcome === 'accepted';
}
